module.exports = __webpack_public_path__ + "img/title-bg.7cf9ce91.png";